import { SxProps, Theme } from '@mui/material/styles';
import { FC, ReactNode } from 'react';
import ArrowButton, { ArrowPosition, ComponentColor } from '../ArrowButton';
import PlainLink from '@components/Links/PlainLink';

interface ArrowLinkProps {
    arrowPosition?: ArrowPosition;
    children?: ReactNode;
    componentColor?: ComponentColor;
    sx?: SxProps<Theme>;
    href: string;
    isExternal?: boolean;
    isLoading?: boolean;
    label?: string;
    onClick?: () => void;
    openInNewTab?: boolean;
}

const ArrowLink: FC<ArrowLinkProps> = ({
    children,
    href,
    onClick,
    openInNewTab = true,
    ...props
}) => (
    <PlainLink href={href} onClick={onClick} openInNewTab={openInNewTab} underline="never">
        <ArrowButton {...props}>{children}</ArrowButton>
    </PlainLink>
);

export default ArrowLink;
